import React, { useState, useEffect } from "react";
import styled from "styled-components";
import Branch from "./Branch";
import { db } from "../../../firebase";
import { doc, getDoc, setDoc } from "firebase/firestore";

const DEFAULT_UID = "bhzfBvdgxZYrvKvDaXz5iaQzIjn1";

function Tree(props) {
  const targetUid = props.uid || DEFAULT_UID;
  const [userCollectionPath, setUserCollectionPath] = useState(
    `trees/users/${targetUid}/${targetUid}`
  );

  useEffect(() => {
    const currentUid = props.uid || DEFAULT_UID;
    setUserCollectionPath(`trees/users/${currentUid}/${currentUid}`);
  }, [props.uid]);

  useEffect(() => {
    const defaultRoot = {
      id: "root",
      _instructions: "welcome to your tree!",
      expand: "clicking on the branch name expands it and gives you extra tools",
      addBranch:
        "try pressing the + button on the top right of the branch to add sub branches",
      images: "store your images here",
    };

    const checkRoot = async () => {
      try {
        const docRef = doc(db, userCollectionPath + "/root", "root");
        const docSnap = await getDoc(docRef);

        if (!docSnap.exists()) {
          await setDoc(docRef, defaultRoot);
        }
      } catch (err) {
        console.error("Error checking root document:", err);
      }
    };

    if (userCollectionPath) {
      checkRoot();
    }
  }, [userCollectionPath]);

  return (
    <Trunk>
      <Branch
        name={"root"}
        id={"root"}
        path={`${userCollectionPath}/root`}
        index={0}
        onPreview={props.onPreview}
      />
    </Trunk>
  );
}

export default Tree;

const Trunk = styled.div`
  position: relative;
  display: inline-block;
  width: max-content;
`;
